import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { selectUser } from '../../features/currentUser/currentUserSelectors';
import { useAppSelector } from '../../hooks/redux';
import { LoginForm } from '../../components/login/LoginForm';
import './login.scss';

export const Login = () => {
  const history = useHistory();
  const { accessToken, refreshToken } = useAppSelector(selectUser);

  useEffect(() => {
    accessToken && refreshToken && history.push('/communities');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, refreshToken]);

  return (
    <div className="raqt-login">
      <div className="raqt-login__main">
        <LoginForm showHeader={true} showLinks={true} />
      </div>
    </div>
  );
};
